import * as Scrivito from "scrivito";
import classNames from "classnames";
import { isBrowser } from "^/utils/isBrowser";
import GenericInputComponent from "../GenericInputComponent";
import FormFieldWrapper from "../FormFieldWrapper";
import {
  formInputId,
  formInputName,
  getValidationResult,
} from "../../formHelpers";
import ErrorBlock from "../ErrorBlock";

class RadioboxWidgetComponent extends GenericInputComponent {
  render() {
    const { widget, inputsWithErrors } = this.props;
    const myStorage = isBrowser ? window.sessionStorage : {};
    const validation = getValidationResult(inputsWithErrors, widget.id());
    return (
      <div
        className={classNames("form-group pt-0", {
          invalid: !!validation,
        })}
      >
        <FormFieldWrapper className="question-box" widget={widget} checkbox>
          <Scrivito.ContentTag
            className="radio-group mt-1"
            content={widget}
            attribute="radioButtons"
            role="radiogroup"
            id={formInputId(widget)}
            widgetProps={{
              handleInputChange: this.changeValue,
              inputName: formInputName(widget),
              radioValue: myStorage.getItem(widget.id()),
            }}
          />
        </FormFieldWrapper>
        <ErrorBlock validation={validation} lang={widget.obj().language()} />
      </div>
    );
  }
}

Scrivito.provideComponent("RadioboxWidget", RadioboxWidgetComponent);
